module.exports = __webpack_public_path__ + "img/hv@Medellin.e958de25.png";